import { Button } from '@vantage-hub/ui'
import { Link } from '@tanstack/react-router'

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-[var(--color-background)]">
      <h1 className="text-6xl font-bold text-[var(--color-primary)]">404</h1>
      <p className="text-[var(--color-muted-foreground)]">Page not found</p>
      <Button asChild>
        <Link to="/">Go home</Link>
      </Button>
    </div>
  )
}
